<div class="minute-input-container" [ngClass]="{big:big, colored: colored}">
	<div class="minute-conteiner">
		<input type="text" placeholder="MM" name="minutes" [(ngModel)]="minutes" (blur)="onChangeHandler()" pattern="^((?!(0[0-9]))[\d]{1,3})$" maxlength="3" [required]="required" style="text-align: right;" >
	</div>
	<div class="divider-container">:</div>
	<div class="minute-conteiner seconds">
		<input type="text" placeholder="SS" name="seconds" [(ngModel)]="seconds" (blur)="onChangeHandler()" pattern="[0-5][0-9]" maxlength="2" [required]="required" style="text-align: left;">
	</div>
</div>